export default {
  name: 'AppConfig',

  dataStore: {
    AppConfig    : 'App.Config',
    AppType      : 'App.Type',
    AppTags      : 'App.Tags',
    AppCart      : 'App.Cart',
    AppPayments  : 'App.Payments',
    AppServices  : 'App.Services',
    AppStores    : 'App.Stores',
    AppCategories: 'App.Categories',
    AppQrItems   : 'App.QrItems',
    AppQrData    : 'App.Type.QrData'
  },

  computed: {
    AppInMaintenanceMode() {
      const appCanSkipMaintenanceModeMode = this.$sessionStorage.hasKey('mma') && this.$sessionStorage.get('mma') === true
      return (this.AppConfig?.Marketplace?.MaintenanceMode ?? false) && !appCanSkipMaintenanceModeMode
    },

    AppOrderTypes() {
      return Object.values(this.$t('Cart.OrderType'))
    },

    AppDeliveryService() {
      return this.AppServices.find(service => service.Code === 'delivery')
    },

    AppSmsService() {
      return this.AppServices.find(service => service.Code === 'sms')
    },

    AppWaiterService() {
      return this.AppServices.find(service => service.Code === 'waiter')
    }
  },

  methods: {}
}
